import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { deleteIcon, tableEditIcon } from "../../../assets/images";
import { formatDate, formateDateTime } from "../../../utils/commonFunctions";
import { HolidayCalenderListType } from "../../../redux/masterData/masterTypes";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  data: HolidayCalenderListType[] | [];
  tableHeader: TableHeadersType[];
  handleEditMasterHolidayCalender?: (data: HolidayCalenderListType) => void;
  handleDeleteHolidayCalender?: (data: HolidayCalenderListType) => void;
  handleShowConfirmationModal?: (data: number) => void;
  isUpdateHolidayCalenderPresent?:boolean;
  isDeleteHolidayCalenderPresent?:boolean;
};
const HolidayCalenderTableData = ({
  data,
  tableHeader,
  handleEditMasterHolidayCalender,
  handleDeleteHolidayCalender,
  handleShowConfirmationModal,
  isUpdateHolidayCalenderPresent,
  isDeleteHolidayCalenderPresent
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((calenderData: any) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "country") {
                    return (
                      <td className="text-left" style={{ minWidth: "150px" }}>
                        {calenderData?.country}
                      </td>
                    );
                  } else if (header?.value == "date") {
                    return (
                      <td className="text-left" style={{ minWidth: "120px" }}>
                        {calenderData?.date
                          ? formatDate(calenderData?.date)
                          : ""}
                      </td>
                    );
                  } else if (header?.value == "description") {
                    return (
                      <td className="text-left" style={{ minWidth: "250px" }}>
                        {calenderData?.description?.length>100 ? 
                        (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view">{calenderData?.description}</Tooltip>
                            }
                          >
                            <span>
                              {calenderData?.description?.substr(0, 100) +
                                (calenderData?.description?.length> 100
                                  ? "..."
                                  : "")}
                            </span>
                          </OverlayTrigger>
                        )
                        : calenderData?.description}
                      </td>
                    );
                  }
                  else if (header?.value == "branch") {
                    return (
                      <td className="text-left" style={{ minWidth: "250px" }}>
                      {calenderData?.branches?.length > 0 ? (() => {
                        const branchNames = calenderData?.branches?.map((item: any) => item?.branch_name).join(", ");
                        
                        return branchNames?.length > 100 ? (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={<Tooltip id="branches-tooltip">{branchNames}</Tooltip>}
                          >
                            <span>{branchNames?.slice(0, 100) + "..."}</span>
                          </OverlayTrigger>
                        ) : (
                          <span>{branchNames}</span>
                        );
                      })() : "NA"}
                    </td>
                    );
                  }
                  else if (header?.value === "updated_by") {
                    return (
                      <td style={{ width: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={calenderData?.updated_by?.first_name}
                          lastName={calenderData?.updated_by?.last_name}
                          profilePic={
                            calenderData?.updated_by?.profile_pic?.file_url
                          }
                          updatedAt={formateDateTime(calenderData?.updated_at)}
                        />
                      </td>
                    );
                  } else if (header?.value == "Edit") {
                    return (
                      <td style={{ textAlign: "left" }}>
                        {isUpdateHolidayCalenderPresent &&
                        <span
                          className="d-inline-block pointer"
                          onClick={() =>
                            handleEditMasterHolidayCalender?.(calenderData)
                          }
                        >
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <img src={tableEditIcon} alt="edit" />
                          </div>
                        </span>
                        }
                        {isDeleteHolidayCalenderPresent && 
                        <span
                          className="d-inline-block pointer ml-2"
                          onClick={() =>
                            handleShowConfirmationModal?.(calenderData?._id)
                          }
                        >
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <img src={deleteIcon} alt="delete" />
                          </div>
                        </span>
                        }
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default HolidayCalenderTableData;
